<template>
  <div class="btn-group btn-group-sm">
    <button class="btn btn-info" title="Reports View"
      :class="{ '-nested-comp-open-btn': isDisplayRowVisible }"
      @click="toggleNestedComp('Reports')">
      <i class="fa fa-list-ul"></i>
    </button>
  </div>
</template>
<script>
import $ from 'jquery';
import common from '@/assets/js/common.js';
export default {
  props: ['row', 'nested'],
  components: {},
  mixins: [common],
  mounted () {
    //$(this.$el).find('button[title]').tooltip()
  },
  computed: {
    isDisplayRowVisible () {
      if (this.nested.comp !== 'Reports') return
      return this.nested.visible
    },
  },
  methods: {
    toggleNestedComp (comp) {
      const { nested } = this
      if (nested.comp === comp) return nested.$toggle()
      nested.$toggle(comp, true)
    }
  }
}
</script>
<style>
.-nested-comp-open-btn {
  color: #fff !important;
  background-color: #337ab7 !important;
}
dd, dt {
    line-height: 1.42857143;
}
</style>
